<template>
  <div v-if="!isHomeIp&&todayCardDatas.length!==0" class="promotion-container">
  <!-- <div  class="promotion-container"> -->
    <div class="promotion-center">
      <h3>PROMOTION</h3>
      <p>（500KG 1.5CBM）</p>
      <div class="line"></div>
      <div class="promotion-card-container">
        <div
          @click="goListPage('card', item)"
          v-for="item in todayCardDatas"
          class="card-item"
        >
          <header class="airline-header">
            <!-- <div class="header-container"> -->
            <h5>{{ item.StartAirportCode3 }}</h5>
            <!-- <div> -->
            <!-- <span>Transit</span> -->
            <el-tooltip
              :content="lineHoverText(item)"
              placement="top"
              effect="light"
            >
              <div class="card-path">
                <span>{{
                  item.AirArrivalType === 2 ? "Transit" : "Direct"
                }}</span>
                <img src="@/assets/img/home_ic_arrows.png" alt="" />
              </div>
            </el-tooltip>

            <!-- </div> -->
            <h5>{{ item.DestAirportCode3 }}</h5>
            <!-- </div> -->
          </header>
          <article>
            <h5>${{ item.Price }}/KG</h5>
            <span class="detail"
              >Transit time：{{ validTerm(item) }}  {{item.MinValidTerm==1&&item.MaxValidTerm==1 ? 'Day':'Days'}}</span
            >
          </article>
          <footer class="airline-footer">
            <div class="footer-icon">
              <!-- <img style="width: 34px" src="@/assets/img/dhl.png" alt="" /> -->
              <!-- 'https://test.by56.com:4823'+ -->
              <img
                @error="(e)=>{e.target.src = require('@/assets/img/place_holder.png');}"
                style="width: 34px"
                :src="item.AirCompanyLogo ||require('@/assets/img/place_holder.png') "
                alt=""
              />

              <span>{{ item.AirCompanyCode2 }}-{{ item.AirCompanyCode3 }}</span>
            </div>
            <a class="select" @click.stop="goListPage('select', item)">SELECT</a>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from "@/ask/axios";
import bus from "@/ask/eventBus";
// import bus from "../../../assets/img/bus.png";

export default {
  data() {
    return {
      ipObj: null,
      isHomeIp: false,
      endAir: [],
      customerOwnerType: 2,
      todayCardDatas: [],
    };
  },
  computed: {
    lineHoverText() {
      return function (item) {
        return `${item.StartAirportCode3}${
          item.TransferAirport ? "-" + item.TransferAirport : ""
        }-${item.DestAirportCode3}`;
      };
    },
  },
  mounted() {
    bus.$on("passEndAir", (res) => (this.endAir = res));

    this.$store.dispatch("user/getIP").then((res) => {
      //console.log("🚀 ~ res", res)
      this.ipObj = res;
      this.getTodayCard();
    });

 
  },
  methods: {
    // 有效期
   validTerm(item){
     if( item.MinValidTerm!==item.MaxValidTerm){
      return `${item.MinValidTerm}-${item.MaxValidTerm}`
     }else{
       return item.MinValidTerm
     }
    },
    // 获取卡片信息
    getTodayCard() {
      if (this.ipObj.GetCountry.CountryEn === "China") {
      // if (false) {
        this.isHomeIp = true
        this.customerOwnerType=1
        return;
      } else {
        
        const url = this.$api04 + "/Air/api/AirCalculation/Today";
        const params = {
          customerOwnerType: this.customerOwnerType,
          destAirportCode:this.ipObj.SysAirPortRet.AirportCode3,
          // destAirportCode:'LAX',
        };
        post(url, params).then(({ Results }) => {
          this.todayCardDatas = Results;
        });
      }
    },
 
    //点击卡片 跳路由
    goListPage(type, item) {
      item.code1 = item.StartAirportCode3
      item.code2 = item.DestAirportCode3
      const strage = {
        token: this.$store.state.user.token,
        query:{
          ...item,
          weight:'500',
          cbm:'1.5', 
          cargoId:sysCfg.air.Cargo.generalCargoID,
          unitQty:'1'
        },
        notLogin: function () {
          //console.log("🚀 ~ this", this);
          if (strage.token) {
            this.$router.push({ path: "/checkList/quotes", query: strage.query });
            return true;
          }
          return false;
        },
        card: function () {
          if (strage.notLogin.call(this)) return;
          this.$router.push({ path: "/front/air", query: strage.query });
        },
        select: function () {
          if (strage.notLogin.call(this)) return;
          this.$alert("You can choose after logging in", "", {
            confirmButtonText: "To log in",
            callback: (action) => {
              this.$router.push({ path: "/reg/login" });
            },
          });
        },
      };
      //console.log("🚀 ~ strage", strage);
      strage[type].call(this, item);
      // debugger
    },
  },
};
</script>

<style lang="scss" scoped>
.promotion-container {
  height: 574px;
  background-color: #f7f7f7;
}
.promotion-center {
  width: 1280px;
  height: 100%;
  margin: 0 auto;
  padding-top: 70px;
  //   background-color: #ccc;
  text-align: center;
  h3 {
    font-size: 30px;
    text-stroke: 1px #333333;
    line-height: 40px;
    color: #333333;
  }
  p {
    line-height: 21px;
    color: #777777;
    font-size: 16px;
  }
  .line {
    @include dividingLine();
    margin: 7px auto 35px;
  }

  .promotion-card-container {
    display: flex;
    justify-content: space-between;
  }
}
.card-item {
  width: 240px;
  height: 300px;
  background: #fff;
  border-radius: 10px;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    //           width: 260px;
    // height: 325px;
    // position:fixed
    transform: scale(1.08);
    transform-origin: bottom;
    box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.15);
  }
  &:hover .select{
    opacity: 1;
  }
  .airline-header {
    height: 95px;
    border-bottom: 1px solid #d9d9d9;
    margin: 0 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    justify-content: space-between;
    h5 {
      text-stroke: 1px #333333;
      line-height: 26px;
      color: #333333;
      font-size: 20px;
      font-weight: 400;
      margin-top: 11px;
    }
  }

  article {
    height: 150px;
    padding-top: 41px;
    box-sizing: border-box;
    h5 {
      color: #333333;
      text-stroke: 1px #333333;
      line-height: 35px;
      font-size: 26px;
    }
    .detail {
      font-size: 15px;
      line-height: 20px;
      color: #777777;
    }
  }
  .airline-footer {
    height: 54px;

    display: flex;
    .footer-icon {
      line-height: 54px;
      flex: 1;
      text-align: left;
      img {
        display: inline-block;
        vertical-align: middle;
        margin: 0 5px 0 10px;
      }
    }
    a {
      background-color: #2e5eb9;
      width: 100px;
      font-size: 20px;
      border-radius: 20px 0px 10px 0px;
      font-weight: 500;
      opacity: 0.7;
      color: #fff;
      line-height: 54px;
      transition: all 0.3s;
      &:hover {
        opacity: 1;
        transform: scale(1.1);
        transform-origin:right bottom;
      }
    }
  }
  // .header-container{
  //     display: flex;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/reception/indexPage/Promotion.vue